import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { WalletListInterface } from '../../types/wallet-list';
import { WalletListFilter } from '../../types/wallet-list-filter';

export const fetchPartnerWalletList = createAction(
  '[Partner Wallet List] Partner Wallet List Fetch',
  props<{ filter?: WalletListFilter }>()
);

export const updatePartnerWalletListFilter = createAction(
  '[Wallet Filter] Partner Wallet List update filter',
  props<{ filter?: WalletListFilter }>()
);

export const loadedPartnerWalletList = createAction(
  '[Partner Wallet List] Partner Wallet List Loaded',
  props<{ dataSource: DataSource<WalletListInterface[]> }>()
);

export const failedPartnerWalletList = createAction(
  '[Partner Wallet List] Partner Wallet List Failed'
);

export const resetPartnerWalletList = createAction(
  '[Partner Wallet List] Reset Partner Wallet List'
);
